import React from "react";

interface MainTabProps {
  active: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

export const MainTab = ({ active, children, onClick }: MainTabProps) => (
  <button
    className={`relative h-[42px] w-[150px] shrink-0 px-3 text-center text-sm font-bold leading-[1.6] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1b4b86] sm:h-[68px] sm:w-[240px] sm:px-[30px] sm:pt-4 sm:text-xl ${
      active ? "bg-[#eef5fa] text-[#1b4b86]" : "bg-white text-[#adbbcc]"
    }`}
    onClick={onClick}
    type="button"
  >
    {children}
    <span
      className={`absolute bottom-0 left-0 h-1 ${
        active ? "w-full bg-[#1b4b86]" : "hidden"
      }`}
    />
  </button>
);

interface QuestTabProps extends MainTabProps {
  widthClass: string;
}

export const QuestTab = ({
  active,
  children,
  widthClass,
  onClick,
}: QuestTabProps) => (
  <button
    className={`relative h-[38px] shrink-0 ${widthClass} px-3 text-center text-sm font-bold leading-[1.6] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1b4b86] sm:h-[46px] sm:px-[25px] sm:pt-2 sm:text-base ${
      active ? "text-[#1b4b86]" : "text-[#adbbcc]"
    }`}
    onClick={onClick}
    type="button"
  >
    {children}
    <span
      className={`absolute bottom-0 left-0 h-1 rounded-[2px] ${
        active ? "w-full bg-[#1b4b86]" : "hidden"
      }`}
    />
  </button>
);
